import { useMemo } from 'react';

import endpoints from '../../services/api/endpoints';
import useFetch from '../../services/api/useFetch';
import * as stringUtil from '../../utils/string-util';

import type {
  ProfileUpdateRequest,
  UserInfoResponse,
} from '../../stores/auth-store/types';
import type { DeleteProfileRequest } from '../../types/user';
export const useAccountApi = () => {
  const api = useFetch();
  return useMemo(() => {
    return {
      async createProfile(
        profile: ProfileUpdateRequest
      ): Promise<UserInfoResponse> {
        try {
          const data: any = await api.postFile(
            endpoints.accounts.create,
            profile
          );
          return { success: true, ...data };
        } catch (error: any) {
          return Promise.reject(error);
        }
      },

      async updateProfile(
        profile: ProfileUpdateRequest
      ): Promise<UserInfoResponse> {
        try {
          const data: any = await api.putFile(
            stringUtil.replace(endpoints.accounts.base, { ':id': '' }),
            profile
          );
          return { success: true, ...data };
        } catch (error: any) {
          return Promise.reject(error);
        }
      },

      async deleteProfile(
        profile: DeleteProfileRequest
      ): Promise<UserInfoResponse> {
        try {
          const data: any = await api.post(
            endpoints.accounts.deleteProfile,
            profile
          );
          return { success: true, ...data };
        } catch (error: any) {
          return Promise.reject(error);
        }
      },

      async userInfo(): Promise<UserInfoResponse> {
        try {
          return await api.get(endpoints.accounts.userInfo);
        } catch (error: unknown) {
          return Promise.reject(error);
        }
      },
    };
  }, [api]);
};
